export const pickRandomFromArray = <T>(arr: T[]): T => {
	const randomIndex = Math.floor(Math.random() * arr.length);

	return arr[randomIndex];
};
export const randomWithClamp = (from: number, to: number) => {
	return Math.floor(Math.random() * (to - from + 1) + from);
};

export function shuffleArray<T>(array: T[]): T[] {
	for (let i = array.length - 1; i > 0; i--) {
		const j = Math.floor(Math.random() * (i + 1));
		[array[i], array[j]] = [array[j], array[i]];
	}
	return array;
}

export const randomPPlusModelsValues = [
	"reliberate_v10.tar",
	"icbinpICantBelieveIts_final.tar",
	"pureperfection_v20.tar",
	"cyberrealistic_v31.tar",
	"dreamshaperv6.tar",
	"edgeOfRealism.tar"
];
export const randomPPlusModelsValuesInpaint = [
	"s3://phygc-sd-weights-inpainting/dreamshaper_8Inpainting.tar",
	"s3://phygc-sd-weights-inpainting/juggernaut_final-inpainting.tar",
	"s3://phygc-sd-weights-inpainting/aZovyaPhotoreal_v2InpaintVAE.tar"
];
export const randomPPlusModelsValuesInpaintPrompt = [
	"s3://phygc-sd-weights-inpainting/Deliberate_v5-inpainting.tar",
	"s3://phygc-sd-weights-inpainting/Reliberate_v3-inpainting.tar"
];
